// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2024-07-17 14:33:25 +0200 (Wed, 17 Jul 2024) $
//  Author    : Olli Powroznik
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 144669 $
//  Purpose   : indicate Scenes and navigate
// =============================================================================
// ---Third-party imports
import React, {useEffect} from 'react'
import clsx from 'clsx'

// ---Framework imports

import log from 'uix/logging'
import {useState, useDimensions} from 'uix/hooks'
// ---Local imports
import S from './slideIndicator.scss'
import {useSubSlideIdSync} from '../hooks'
import {sub} from 'date-fns'

// ---Exports

export const SlideIndicator = ({
  progress,
  slides,
  activeSlide,
  setActiveSlide,
  position = 'left',
  className,
}) => {
  let [dimensions, ref] = useDimensions({delta: 1})
  let [hovered, setHovered] = useState(false)
  let [index, setIndex] = useState(0)
  let activSlideIdx = progress > 65 ? activeSlide + 1 : activeSlide
  let activeSlides = slides.filter(slide => {
    return !slide.isRoomSlide && slide.room == slides[activSlideIdx]?.room
  })
  let subslides = slides[activeSlide]?.subslides.length > 0 ? true : false

  // takes last scene with menu entry if scene is hidden in menu
  useEffect(() => {
    let slide = slides[activSlideIdx]
    if (slide) {
      activeSlides?.map((e, i) => {
        if (slide.isRoomSlide) {
          setIndex(-1)
        } else {
          if (slide.otid == e.otid && !e.meta?.hideInMenu) {
            setIndex(i)
          }
        }
      })
    }
  }, [activSlideIdx])

  // Entrance animation on roomSlide
  useEffect(() => {
    let roomSlide = slides[activSlideIdx || activSlideIdx + 1]?.isRoomSlide
    let progressRange = progress > 75 || progress === 0 || progress === null
    if (roomSlide && progressRange) {
      setHovered(true)
    } else {
      setHovered(false)
    }
  }, [progress])

  let posClass = {}
  if (position == 'left') {
    posClass = S.left
  }

  let render = activeSlides?.map((e, i) => {
    let active = index === i
    let clickHandle = () => {
      setActiveSlide(e.index)
    }

    if (!e.meta?.hideInMenu && e.caption && !activeSlide == 0) {
      return (
        <div key={e.otid} onClick={clickHandle} className={clsx(S.indicator, active && S.active)}>
          <div className={S.dot}></div>
          <div className={S.captionWrapper}>
            <span className={S.caption}>{e.caption}</span>
          </div>
        </div>
      )
    }
  })
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      ref={ref}
      style={{top: `calc(50% - ${Math.round(dimensions.height / 2)}px`}}
      className={clsx(
        S.slideIndicator,
        posClass,
        hovered && S.hovered,
        subslides && S.subslides,
        className
      )}
    >
      {render}
    </div>
  )
}
